import redditImg from '../../assets/images/reddit.png';
import hackernewsImg from '../../assets/images/hackernews2.png';

const CDN = "https://cdn.prod.website-files.com/602f5458a0b1d868c6c84d5b";

const cards = [
  {
    stat: "1M+",
    label: "DOWNLOADS ON HUGGINGFACE",
    alt: "Nanonets OCR model — 1M+ downloads on HuggingFace",
    image: `${CDN}/690d9c267ab3969cf5a6eabd_community_img1.png`,
    href: "https://huggingface.co/nanonets",
  },
  {
    stat: "#1",
    label: "POST ON HACKER NEWS",
    alt: "#1 post on Hacker News — Nanonets document parsing and extraction model launch",
    image: `${CDN}/690d9c268ca7f2e036f8f702_community_img2.png`,
    href: "https://news.ycombinator.com/item?id=44287043",
  },
  {
    stat: "X",
    label: "Devs rave about our models",
    alt: "Developers on X praising Nanonets document AI and OCR models",
    image: `${CDN}/690d9c270e0e0f2a06b2913d_community_img3.png`,
    href: "https://x.com/nanonets",
  },
  {
    stat: "100k+",
    label: "VIEWS ON THOUGHT PIECES ON LLM TECH",
    alt: "100k+ views on Nanonets AI and document extraction thought leadership",
    image: redditImg,
    href: "https://nanonets.com/blog/ai-warfare-operation-epic-fury-2026/",
  },
  {
    stat: "HN",
    label: "Developer insights from our team",
    alt: "Nanonets team developer insights on Hacker News — document parsing and AI",
    image: hackernewsImg,
    href: "https://news.ycombinator.com/item?id=46635309",
  },
];

export default function Community() {
  return (
    <section className="py-20 bg-[#F8FAFF]">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <p className="text-[#546FFF] text-sm font-semibold tracking-widest uppercase mb-3">
            OPEN-source contributions
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#080808] mb-4">
            Community Pulse
          </h2>
          <p className="text-[#08080899] text-lg max-w-[700px] mx-auto">
            Sharing open-source models, innovations, knowledge with the developer community helps us on our path to be pioneering contributors to document AI.
          </p>
        </div>

        {/* Row 1 — 3 cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {cards.slice(0, 3).map((card, i) => (
            <Card key={i} card={card} />
          ))}
        </div>

        {/* Row 2 — 2 cards centered */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:max-w-[816px] md:mx-auto">
          {cards.slice(3).map((card, i) => (
            <Card key={i} card={card} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ card }) {
  return (
    <a
      href={card.href}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white rounded-2xl overflow-hidden shadow-sm border border-[#F0F0F0] flex flex-col hover:shadow-md hover:border-[#D0D0D0] transition-all duration-200 cursor-pointer"
    >
      <div className="p-6 pb-4">
        <h3 className="text-3xl md:text-4xl font-bold text-[#080808] mb-1">{card.stat}</h3>
        <p className="text-sm font-semibold text-[#08080899] tracking-widest uppercase">
          {card.label}
        </p>
      </div>
      <div className="w-full relative overflow-hidden" style={{ paddingBottom: '74%' }}>
        <img
          src={card.image}
          alt={card.alt}
          loading="lazy"
          decoding="async"
          style={{ position: 'absolute', top: 0, left: 0, width: '100%' }}
        />
      </div>
    </a>
  );
}
